import styled, { css } from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import Label from '../Label'

const margin = ifProp('prepend', css`
  margin-right: .75em;
`, css`
  margin-left: .75em;
`)

const CheckboxFieldLabel = styled(Label)`
  flex: 1;
  font-size: .75em;
  ${margin}
`

export default CheckboxFieldLabel
